// components/AnimatedCoin.jsx
import React from 'react';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 100% { transform: translateY(0) rotate(0); }
  25% { transform: translateY(-20px) rotate(15deg); }
  50% { transform: translateY(0) rotate(0); }
  75% { transform: translateY(-10px) rotate(-15deg); }
`;

const CoinWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem auto;
  animation: ${bounce} 2s infinite;
`;

const Coin = styled.div`
  width: 60px;
  height: 60px;
  background: radial-gradient(circle at 30% 30%, #FFB800, #FF7C24);
  border-radius: 50%;
  border: 3px solid #fff;
  box-shadow: 0 0 10px #FFB800;
`;

const AnimatedCoin = () => {
  return (
    <CoinWrapper>
      <Coin />
    </CoinWrapper>
  );
};

export default AnimatedCoin;
